import React from 'react';

import { VwpProvider } from './VwpContext';

import Filters from './Filters/Filters';
import PackageList from './PackageList/PackageList';
import SideBar from './SideBar/SideBar';
import SupplierPackageDetails from './SupplierPackageDetails/SupplierPackageDetails';

import scss from './WeddingSupplierPackages.module.scss';
import { VwpCategory, VwpReview } from './types';

interface WeddingSupplierPackagesProps {
  regionId?: number;
  vwpCategories: VwpCategory[];
  vwpReviews?: VwpReview[];
  facebookAppId: string;
  enableGTMTracking: boolean;
}

const WeddingSupplierPackages = ({ regionId, vwpCategories, vwpReviews, facebookAppId, enableGTMTracking }: WeddingSupplierPackagesProps) => {
  return (
    <VwpProvider
      regionId={regionId}
      facebookAppId={facebookAppId}
      vwpCategories={vwpCategories}
      vwpReviews={vwpReviews}
      enableGTMTracking={enableGTMTracking}
    >
      <div className={scss.mainContainer}>
        <div>
          <Filters />
          <PackageList />
        </div>
        <SideBar />
      </div>
      <SupplierPackageDetails />
    </VwpProvider>
  );
};

export default WeddingSupplierPackages;
